import clsx from 'clsx'
import { INotificationConfig, NotififcationPresets, SystemNotifiactionIcon } from '../notifications.type'
import { Trans } from '@lingui/react'

import style from './style.module.scss'

interface ITigerXTechnicalWorkAlertConfig {
  isMobile: boolean
}

export const getTigerXTechnicalWorkAlert = ({ isMobile }: ITigerXTechnicalWorkAlertConfig) => {
  const now = new Date().getTime()

  const endDate = new Date('2025-04-28')
  endDate.setHours(23, 59, 59, 999)

  const preset: INotificationConfig = {
    id: NotififcationPresets.TigerXTechnicalWork,
    icon: SystemNotifiactionIcon.Alert,
    heading: (
      <span className={clsx(isMobile && style.mobile, style.label)}>
        <Trans
          id={'core.systemAlert.tigerXTechnicalWorks.label'}
          components={{
            gradientText: <span className={style.gradient} />,
          }}
        />
      </span>
    ),
    description: <Trans id="core.systemAlert.tigerXTechnicalWork.description" />,
    shouldShown: false,
    availableExchange: ['TIGER_X'],
  }

  return preset
}
